import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { LazyAction, LazyModule } from 'owa-bundling';
import { ShowQuickComposeState } from 'owa-calendar-compose-form-store/lib/quickCompose/actionsV2/showQuickCompose';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "QuickComposeIndex", webpackPrefetch: true */ '../lazyIndex')
);

export let lazyShowQuickCompose = new LazyAction(lazyModule, m => m.showQuickCompose);
export { CalendarEvent, ShowQuickComposeState };
